import React, { ReactElement } from 'react';
import { HomePage } from '../../pages/Home/HomePage';
import { AssetPage } from '../../pages/Asset/index';
import { InfoPage } from '../../pages/AppInfo';
import { PlannedQtyPage } from '../../pages/PlannedQty/index';
import { MasterDataRedirect } from '../../pages/MasterDataRedirect/MasterDataRedirect';
import { DashboardPerformance } from '../../pages/Dashboard/PerformanceDashboard/DashboardPerformance';
import { DashboardPerformanceHistory } from '../../pages/Dashboard/PerformanceHistoryDashboard/DashboardPerformanceHistory';
import { DashboardCycleTimeHistory } from '../../pages/Dashboard/DashboardCycleTimeHistory/DashboardCycleTimeHistory';
import { DashboardStateHistory } from '../../pages/Dashboard/DashboardStateHistory/DashboardStateHistory';
import { LoginPage } from '../../pages/Login/LoginPage';
import { LogoutPage } from '../../pages/Logout/LogoutPage';
import { DashboardPerformanceComment } from '../../pages/Dashboard/PerformanceCommentDashboard/PerformanceCommentDashboard';
import { DashboardOpc } from '../../pages/Dashboard/DashboardOpc/DashboardOpc';

interface AppRoute {
  path: string;
  component: ReactElement;
}

export const paths = {
  HOME: '/',
  APP_INFO: '/appInfo',
  // Assets
  ASSETS_LIST: '/assets',

  PLANNED_QTY_LIST: '/planned-qty',
  PLANNED_QTY_CREATE: '/planned-qty-create',
  PLANNED_QTY_DETAIL: '/planned-qty-detail',

  PLANNED_QTY_DEVIATION_LIST: '/planned-qty',
  PLANNED_QTY_DEVIATION_CREATE: '/planned-qty-deviation-create',
  PLANNED_QTY_DEVIATION_DETAIL: '/planned-qty-deviation-detail',

  MASTER_DATA_REDIRECT: '/master-data',
  // Dashboards
  DASHBOARD_PERFORMANCE: '/performance-dashboard',
  DASHBOARD_PERFORMANCE_HISTORY: '/performance-history-dashboard',
  DASHBOARD_CYCLE_TIME_HISTORY: '/cycle-time-history-dashboard',
  DASHBOARD_STATE_HISTORY: '/state-history-dashboard',
  DASHBOARD_OPC: '/opc-dashboard',
  DASHBOARD_COMMENT: '/comment-dashboard',
  HISTORY_CYCLE_TIME: '/history-cycle-time',
  HISTORY_STATE: '/history-state',

  LOGIN_PAGE: 'login',
  LOGOUT_PAGE: 'logout',
};

export const fullscreenPathPrefix = '/fullscreen';
export const pathFullscreen = {
  DASHBOARD: `${fullscreenPathPrefix}/dashboard`,
};

export const routes: AppRoute[] = [
  {
    path: paths.HOME,
    component: <HomePage />,
  },
  {
    path: paths.LOGIN_PAGE,
    component: <LoginPage />,
  },
  {
    path: paths.LOGOUT_PAGE,
    component: <LogoutPage />,
  },
  {
    path: paths.ASSETS_LIST,
    component: <AssetPage />,
  },
  {
    path: `${paths.ASSETS_LIST}/:assetId/:name${paths.DASHBOARD_PERFORMANCE_HISTORY}`,
    component: <DashboardPerformanceHistory />,
  },
  {
    path: `${paths.ASSETS_LIST}/:assetId/:name${paths.DASHBOARD_CYCLE_TIME_HISTORY}`,
    component: <DashboardCycleTimeHistory />,
  },
  {
    path: `${paths.ASSETS_LIST}/:assetId/:name${paths.DASHBOARD_STATE_HISTORY}`,
    component: <DashboardStateHistory />,
  },
  {
    path: `${paths.ASSETS_LIST}/:assetId/:name${paths.DASHBOARD_COMMENT}`,
    component: <DashboardPerformanceComment />,
  },
  {
    path: `${paths.ASSETS_LIST}/:parentId/:name${paths.DASHBOARD_PERFORMANCE}/:id`,
    component: <DashboardPerformance />,
  },
  {
    path: `${paths.ASSETS_LIST}/:parentId/:name${paths.DASHBOARD_OPC}/:id`,
    component: <DashboardOpc />,
  },
  {
    path: `${paths.PLANNED_QTY_LIST}/:id/:name`,
    component: <PlannedQtyPage />,
  },
  {
    path: paths.MASTER_DATA_REDIRECT,
    component: <MasterDataRedirect />,
  },
  {
    path: paths.APP_INFO,
    component: <InfoPage />,
  },
];

const fullscreenDashboardPerformanceBase = `${pathFullscreen.DASHBOARD}/:parentId/:name${paths.DASHBOARD_PERFORMANCE}/:id`;
export const routesFullscreen: AppRoute[] = [
  {
    // http://localhost:44480/fullscreen/dashboard/1/RE-L/dashboard/1
    path: fullscreenDashboardPerformanceBase,
    component: <DashboardPerformance />,
  },
  {
    path: `${fullscreenDashboardPerformanceBase}/:lang`,
    component: <DashboardPerformance />,
  },
  {
    path: `${fullscreenDashboardPerformanceBase}/:timezone`,
    component: <DashboardPerformance />,
  },
  {
    path: `${fullscreenDashboardPerformanceBase}/:lang/:timezone`,
    component: <DashboardPerformance />,
  },

  // OPC
  {
    path: `${pathFullscreen.DASHBOARD}/:parentId/:name${paths.DASHBOARD_OPC}/:id/:lang`,
    component: <DashboardOpc />,
  },
];
